import api from '../auth';
const slug = 'api/namena_potrosnjes/';

const NamenaPotrosnjeService = () => {
    const getNamenaPotrosnjes = () => {
        return api.get(slug).then((res) => res.data);
    };

    const getNamenaPotrosnjesLazy = (params) => {
        return api
            .get(slug, {
                params
            })
            .then((res) => res.data);
    };

    const getNamenaPotrosnje = (id) => {
        return api.get(slug + `show/${id}/`).then((res) => res.data);
    };

    const deleteNamenaPotrosnje = (id) => {
        return api
            .delete(slug + `namena_potrosnje/${id}/`)
            .then((res) => res.data)
            .catch((err) => {
                return err;
            });
    };

    const createNamenaPotrosnje = (data) => {
        return api.post(slug, data).then((res) => res.data);
    };

    const updateNamenaPotrosnje = (id, data) => {
        return api.put(slug + `namena_potrosnje/${id}/`, data).then((res) => res.data);
    };

    const getOptions = () => {
        return api.options(slug).then((res) => res.data.actions.POST);
    };

    // custom action
    const copyNamenaPotrosnje = (id) => {
        return api.post(slug + `copy/${id}/`).then((res) => res.data);
    };

    return {
        getNamenaPotrosnjes,
        getNamenaPotrosnjesLazy,
        getNamenaPotrosnje,
        deleteNamenaPotrosnje,
        createNamenaPotrosnje,
        updateNamenaPotrosnje,
        getOptions,
        copyNamenaPotrosnje
    };
};

export default NamenaPotrosnjeService;
